/**
 * Welcome offer popup behavior.
 *
 * QA fix (Audit Fixes 3 QA pass): this used to fetch the actual discount
 * code from a public theme asset after submit. That asset was reachable by
 * anyone who requested its URL directly -- submitting the form was never
 * required to get the code, and there's no way to gate a static theme
 * asset per-visitor. The code is no longer present in front-end code at
 * all: submitting just tags the customer and shows a generic "check your
 * email" confirmation. The real code is delivered by the store's email
 * automation (Shopify Email / Klaviyo), set up separately from the theme.
 *
 * Signup fix (Oct 2026): submission is now a native Shopify customer form
 * post instead of a fetch() to "/" (which never created a customer).
 */
(function () {
  var KEY = 'togekid_welcome_popup';
  var root = document.getElementById('WelcomePopup');
  if (!root) return;
  var isEditor = window.Shopify && Shopify.designMode;
  var rootUrl = root.getAttribute('data-root-url') || '/';

  function seen() {
    try { return !!localStorage.getItem(KEY); } catch (e) { return false; }
  }
  function markSeen() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
  function open() { root.hidden = false; }
  function close() { root.hidden = true; markSeen(); }

  function showConfirmation() {
    root.querySelector('[data-wpop-step="form"]').hidden = true;
    root.querySelector('[data-wpop-step="code"]').hidden = false;
  }

  root.querySelectorAll('[data-wpop-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  // Signup fix (Oct 2026): the form is now a native Shopify customer form
  // (see snippets/welcome-popup.liquid) and submits normally -- no fetch.
  // Shopify redirects back to this page with ?customer_posted=true#WelcomePopupForm
  // (or shows its own bot check first). On that return, re-open the popup on
  // the confirmation step; on a form error, re-open it on the form so the
  // shopper sees the message.
  var form = root.querySelector('.wpop__form');
  if (form) form.addEventListener('submit', function () { markSeen(); });

  var postedHere = /customer_posted=true/.test(location.search) && location.hash === '#WelcomePopupForm';
  if (postedHere && root.querySelector('[data-wpop-posted]')) {
    showConfirmation();
    open();
    markSeen();
    return;
  }
  if (location.hash === '#WelcomePopupForm' && root.querySelector('[data-wpop-error]')) {
    open();
    return;
  }

  if (isEditor) { open(); return; }       // always show in theme editor preview
  if (seen()) return;

  var opened = false;
  function maybeOpen() {
    if (opened) return;
    opened = true;
    open();
  }

  // Show after 20s for everyone.
  var delayTimer = setTimeout(maybeOpen, 20000);

  // Exit intent (desktop only): open immediately instead of waiting out
  // the 20s if the cursor heads off the top of the page.
  if (window.matchMedia && window.matchMedia('(min-width: 750px)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (opened) return;
      if (e.clientY <= 0 && !e.relatedTarget) {
        clearTimeout(delayTimer);
        maybeOpen();
      }
    });
  }
})();
